module.exports = __webpack_public_path__ + "img/W.16d1022.webp";